// extracted by mini-css-extract-plugin
export default {"container":"v8EaBOiR3uBXhP1QGfuz"};